import { render, staticRenderFns } from "./FactoryStatusLegend.vue?vue&type=template&id=135188f9"
import script from "./FactoryStatusLegend.vue?vue&type=script&lang=js"
export * from "./FactoryStatusLegend.vue?vue&type=script&lang=js"
import style0 from "./FactoryStatusLegend.vue?vue&type=style&index=0&id=135188f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports